import React, { useEffect, useState } from "react";
import axios from "axios";
import "../css/vehicle.css";
import AdNav from "../components/adNav";
import Time from "../components/time";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";

const FlashNewsList = () => {
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await axios.get("https://rfs2.infraconsoft.net.in/api/flashNews_list");

      console.log("API Response:", response.data.ListData);
      setData(response.data.ListData);
      setFilteredData(response.data.ListData);
    } catch (error) {
      console.error("Error fetching ListData:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!"
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
           Swal.fire({
                      title: "Submitting...",
                      text: "Please wait while we process your request.",
                      allowOutsideClick: false,
                      didOpen: () => {
                          Swal.showLoading();
                      },
                  });
          await axios.delete(`https://rfs2.infraconsoft.net.in/api/flashNews_delete/${id}`);
          setData(data.filter((item) => item.SlNo !== id));
          setFilteredData(filteredData.filter((item) => item.SlNo !== id));

          Swal.fire({
            title: "Deleted!",
            text: "Your record has been deleted.",
            icon: "success"
          });
        } catch (error) {
          console.error("Error deleting Admin:", error);
          Swal.fire({
            title: "Error!",
            text: "Failed to delete Admin.",
            icon: "error"
          });
        }
      }
    });
  };


  const handleUpdateApprove = async () => {
    const checkboxes = document.querySelectorAll('.admin-checkbox-input.approve');
    const selectedView = [];
  
    checkboxes.forEach((cb) => {
      if (cb.checked) {
        selectedView.push(parseInt(cb.value));
      }
    });
  
    try {
          Swal.fire({
                    title: "Submitting...",
                    text: "Please wait while we process your request.",
                    allowOutsideClick: false,
                    didOpen: () => {
                        Swal.showLoading();
                    },
                });
        
      await axios.put("https://rfs2.infraconsoft.net.in/api/flashnews_ListApprove", {
        selectedView,
      });
      Swal.fire("Success", "Permissions updated successfully", "success");
      fetchData(); // Refresh data
    } catch (error) {
      console.error("Error updating view permissions:", error);
      Swal.fire("Error", "Something went wrong", "error");
    }
  };

  const handleUpdateDisApprove = async () => {
    const checkboxes = document.querySelectorAll('.admin-checkbox-input.disApprove');
    const selectedView = [];
  
    checkboxes.forEach((cb) => {
      if (cb.checked) {
        selectedView.push(parseInt(cb.value));
      }
    });
  
    try {
          Swal.fire({
                    title: "Submitting...",
                    text: "Please wait while we process your request.",
                    allowOutsideClick: false,
                    didOpen: () => {
                        Swal.showLoading();
                    },
                });
        
      await axios.put("https://rfs2.infraconsoft.net.in/api/flashnews_ListDisApprove", {
        selectedView,
      });
      Swal.fire("Success", "Permissions updated successfully", "success");
      fetchData(); // Refresh data
    } catch (error) {
      console.error("Error updating view permissions:", error);
      Swal.fire("Error", "Something went wrong", "error");
    }
  };




  const handleSearch = (e) => {
    const term = e.target.value.toLowerCase();
    setSearchTerm(term);
  
    if (term === "") {
      setFilteredData(data);
      return;
    }
  
    const filtered = data.filter((item) =>
      (String(item.Heading || "").toLowerCase().includes(term))
    );
  
    setFilteredData(filtered);
  };
  


  // Pagination
  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentData = filteredData.slice(indexOfFirstItem, indexOfLastItem);

  return (
    <div id="admin-container">
      <AdNav />
      <div className="content-right">
        <section>
          <h2 className="add-txt">Flash News List</h2>
          <Time />
        </section>


        {/* Add New Button */}
        <div className="add-new-container">
          <Link to={`/admin/flashNewsEntry`}>
            <button className="add-new-btn">
              <i className="fa-solid fa-plus"></i> Add New
            </button>
          </Link>
        </div>

        {/* Search Filter */}
        <div className="search-filter">
          <p>Search: </p>
          <input
            type="text"
            placeholder="Search by User name"
            value={searchTerm}
            onChange={handleSearch}
            className="search-input"
          />
        </div>

        {/* Table */}
        <div className="content-table">
          <table>
            <thead>
              <tr>
                <th>S.No</th>
                <th>Heading</th>
                <th>Edit</th>
                <th><button className="update-btn" onClick={handleUpdateApprove}> Approve</button></th>
                <th><button className="update-btn" onClick={handleUpdateDisApprove}> Dis Approve</button></th>
                <th>Delete</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="6" className="loading-text">Loading data, please wait...</td>
                </tr>
              ) : currentData.length > 0 ? (
                currentData.map((item, index) => (
                  <tr key={index}>
                    <td>{indexOfFirstItem + index + 1}</td>
                    <td>{item.Heading}</td>
                     <td><Link to={`/admin/flashNewsEdit/${item.SlNo}`}>Edit</Link></td>
                     <td>
                        {item.Approve?.toLowerCase().trim() === 'yes' ? (
                            <span style={{color: 'green', fontWeight: 'bold'}}>Approved</span>
                        ) : (
                            <input
                            type="checkbox"
                            value={item.SlNo}
                            className="admin-checkbox-input approve"
                            />
                        )}
                    </td>

                    <td>
                    {item.Approve?.toLowerCase().trim() === 'no' ? (
                        <span style={{color: 'red', fontWeight: 'bold'}}>Dis Approved</span>
                    ) : (
                        <input
                        type="checkbox"
                        value={item.SlNo}
                        className="admin-checkbox-input disApprove"
                        />
                    )}
                    </td>
                    <td className="del">
                      <i className="fa-solid fa-trash-can " onClick={() => handleDelete(item.SlNo)}></i>
                    </td>
                    
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6">No Data Available</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        <div className="pagination">
          <button onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}>
            Previous
          </button>

          {/* Always show first page */}
          <button onClick={() => paginate(1)} className={currentPage === 1 ? 'active' : ''}>
            1
          </button>

          {/* Show up to 3 pages dynamically */}
          {filteredData.length > 0 &&
            [...Array(Math.min(3, Math.ceil(filteredData.length / itemsPerPage) - 1))].map((_, index) => {
              const pageNumber = currentPage + index;
              if (pageNumber > 1 && pageNumber <= Math.ceil(filteredData.length / itemsPerPage)) {
                return (
                  <button key={pageNumber} onClick={() => paginate(pageNumber)} className={currentPage === pageNumber ? 'active' : ''}>
                    {pageNumber}
                  </button>
                );
              }
              return null;
            })
          }

          {/* Next button */}
          <button onClick={() => paginate(currentPage + 1)} disabled={currentPage === Math.ceil(filteredData.length / itemsPerPage)}>
            Next
          </button>
        </div>
      </div>
    </div>
  );
};

export default FlashNewsList;
